import React from "react";
import { Link } from "react-router-dom";
import "../styles/ContactBand.css";
import { company } from "../data/site";

export default function ContactBand() {
	return (
		<section id="contact" className="contact-band" aria-labelledby="contact-title">
			<div className="wrap contact-band__grid">
				<div>
					<h2 id="contact-title">Have a drawing? Send it over.</h2>
					<p className="contact-band__text">
						Tell us the material, quantity and tolerances, and we'll get back to you with a
						quote.
					</p>
					<Link to="/quote" className="button button--primary">
						Request a quote
					</Link>
				</div>
				<dl className="contact-band__details">
					<div>
						<dt>Call</dt>
						<dd>
							<a href={company.phoneHref}>{company.phone}</a>
						</dd>
					</div>
					<div>
						<dt>Email</dt>
						<dd>
							<a href={`mailto:${company.email}`}>{company.email}</a>
						</dd>
					</div>
					<div>
						<dt>Visit</dt>
						<dd>
							<a href={company.mapUrl} target="_blank" rel="noreferrer">
								{company.street}, {company.city}, {company.region} {company.postal}
							</a>
						</dd>
					</div>
				</dl>
			</div>
		</section>
	);
}
